import { getNetwork } from '../utils/getNetwork';
import { API_ROOT } from '../config';

export const getListEventApi = () => getNetwork().get(`${API_ROOT}/edu-activity`);
export const updateEventApi = (data) => getNetwork().put(`${API_ROOT}/edu-activity`, data);
export const createEventApi = (data) => getNetwork().post(`${API_ROOT}/edu-activity`, data);
export const deleteEventApi = (id) => getNetwork().delete(`${API_ROOT}/edu-activity/${id}`);
export const getChaptersApi = () => getNetwork().get(`${API_ROOT}/edu-activity/chapter`);
export const getCategoriesApi = () => getNetwork().get(`${API_ROOT}/edu-activity/category`);
export const getSubCategoriesApi = () => getNetwork().get(`${API_ROOT}/edu-activity/sub-category`);
